export default "__VITE_ASSET__a54b6df1__"